import kvSyncApi from '@/api/kvSync.js'
import kvSyncSubscriber from '@/mqtt/kvSync'

const _state = {}

const actions = {
  fetchValueByKeyAction: async ({ dispatch }, payload) => {
    if (!payload.key) return
    const value = await kvSyncApi.getValueByKey(payload.key)
    dispatch('updateKeyValueAction', {
      key: payload.key,
      value,
    })
  },

  createKeyValueAction: async (_, payload) => {
    await kvSyncApi.createKeyValue(payload)
  },

  subscribeKeyAction: async ({ dispatch }, payload) => {
    dispatch('fetchValueByKeyAction', payload.key)
    kvSyncSubscriber.subscribeKey(payload.key, (topic, message) => {
      dispatch('updateKeyValueAction', {
        key: topic,
        value: message,
      })
      if (payload.callback) {
        payload.callback(topic, message)
      }
    }, payload.options)
  },

  updateKeyValueAction: () => {}, // only declare the action, plugins will listen to this to update state accordingly

  unsubscribeKeyAction(_, payload) {
    kvSyncSubscriber.unsubscribeKey(payload)
  },
}

export default {
  namespaced: true,
  state: _state,
  actions,
}
